import React from "react";
import IconButton from "@material-ui/core/IconButton";
import 'bootstrap/dist/css/bootstrap.css';
import RefreshIcon from '@mui/icons-material/Refresh';
const { Component } = React;

export default class MetaData extends Component {

  constructor(props) {
    super(props);
    this.reload = props.reload;
  }

  calculateTotal(data) {
    var count = 0;
    data.total.segments.forEach((segment) => {
      count += segment.value;
    });
    return count;
  }

  render() {
    return (
      <div>
        <p style={{ fontSize: "1.5em", textAlign: "left", fontWeight: "bold"}}>Datos en vivo</p>
        <p style={{ fontSize: "0.9em", textAlign: "left", color: "gray"}}>{ this.props.data != null ? (new Date(this.props.data.snapTime)).toLocaleString() : "" }
        <IconButton onClick={() => this.reload()} color={this.props.loading ? "gray" : "primary"}  size="small" style={{marginLeft:"4px"}}>
          <RefreshIcon fontSize="inherit"/>
        </IconButton>
        </p>
        <p style={{ marginTop: "8px", fontSize: "1.0em", textAlign: "left"}}>Actualmente hay <b>{ this.props.data != null ? this.calculateTotal(this.props.data) : 0}</b> usuarios compartiendo datos.</p>
      </div>
    )
  }
}
